import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {CommonService} from "../../../shared/services/common.service";
import {UserManagerService} from "../../../shared/services/user-manager.service";
import {MemberService} from "../../../account/services/member.service";
import {OwnershipService} from "../../../shared/services/ownership.service";
import {CrmManagerService} from "../../../shared/services/crm-manager.service";
import { LogService } from '../../../../services/log.service';

@Component({
    selector: 'app-mineside-redirect',
    templateUrl: './mineside-redirect.component.html',
    styleUrls: ['./mineside-redirect.component.scss'],
    standalone: false
})
export class MinesideRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private userManagerService: UserManagerService,
    private memberService: MemberService,
    private ownershipService: OwnershipService,
    private crmService: CrmManagerService
    ) {
    this.loadData_stage1();
  }

  private redirected = false;
  loadedApi1 = false;
  loadedApi2 = false;
  loadedApi3 = false;
  loadedApi4 = false;
  loadedApi5 = false;
  loadedApi6 = false;
  loadData_stage1() {
    this.spinner.show();
    /* #1. LOADING USER INFO */
    this.userManagerService.getUserInfo().subscribe((response: any) => {
      this.loadedApi1 = true;
      this.commonService.setAuthUser(response);
      this.checkIfAllRequiredDataIsLoaded_stage1();
    }, error => {
      this.loadedApi1 = true;
      LogService.debug('Error - userManagerService.getUserInfo()', error);
      this.checkIfAllRequiredDataIsLoaded_stage1();
    });
    /* #2. LOADING USER ROLES */
    this.userManagerService.getAllUserRoles().subscribe((response: any) => {
      this.loadedApi2 = true;
      this.commonService.setAuthRoles(response);
      this.checkIfAllRequiredDataIsLoaded_stage1();
    }, error => {
      this.loadedApi2 = true;
      LogService.debug('Error - userManagerService.getAllUserRoles()', error);
      this.checkIfAllRequiredDataIsLoaded_stage1();
    });
  }

  loadData_stage2() {
    this.spinner.show();
    /* #3. LOADING ASSOCIATED MEMBERSHIPS */
    this.commonService.setMembershipsLoading(true);
    this.memberService.getMemberships().subscribe((response: any) => {
      this.loadedApi3 = true;
      this.commonService.setMembershipsLoading(false);
      this.commonService.setAuthMemberships(response);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    }, error => {
      this.loadedApi3 = true;
      this.commonService.setMembershipsLoading(false);
      LogService.debug('Error - memberService.getMemberships()', error);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    });
    // #4. LOADING ASSOCIATED OWNERSHIPS
    this.ownershipService.getUserOwnerships().subscribe((response: any) => {
      this.loadedApi4 = true;
      this.commonService.setAuthOwnerships(response);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    }, error => {
      this.loadedApi4 = true;
      LogService.debug('Error - ownershipService.getUserOwnerships()', error);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    });

    // #5. LOADING POA DATA
    this.crmService.getPowerOfAttorneyData().subscribe((response: any) => {
      this.loadedApi5 = true;
      this.commonService.setAuthPoaData(response);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    }, error => {
      this.loadedApi5 = true;
      LogService.debug('Error - ownershipService.getUserPoAOwnerships()', error);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    });

    this.memberService.getPoAMemberships().subscribe((response: any) => {
      this.loadedApi6 = true;
      this.commonService.setAuthPoaMemberships(response);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    }, error => {
      this.loadedApi6 = true;
      LogService.debug('Error - memberService.getPoAMemberships()', error);
      this.checkIfAllRequiredDataIsLoaded_stage2();
    });
  }

  checkIfAllRequiredDataIsLoaded_stage1() {
    if(this.loadedApi1 && this.loadedApi2){
      if(this.commonService.getAuthNIN()){
        this.loadData_stage2();
      }else{
        this.loadedApi3  = true;
        this.loadedApi4 = true;
        this.loadedApi5 = true;
        this.checkIfAllRequiredDataIsLoaded_stage2()
      }
    }
  }
  checkIfAllRequiredDataIsLoaded_stage2() {
    if(this.loadedApi1 && this.loadedApi2 && this.loadedApi3 && this.loadedApi4 && this.loadedApi5){
      this.commonService.setProfileLoading(false);
      this.spinner.hide();
      if (this.redirected) {
        return;
      }
      this.redirected = true;
      this.commonService.redirectToDefaultPage();
    }
  }

  ngOnInit(): void {
  }

}
